import { packagePickerErrorSrc17Evid2236 } from '@wix/bi-logger-premium-data/v2';
import { QueriesErrorObserver } from '@wix/premium-fed-sdk/@apis-infra-react';
import React from 'react';
import { getStaticBiEventsFields, useBiLogger, useEclipsePanorama } from '../../hooks';
const extractRequestId = error => {
  var _response;
  return typeof error === 'object' && !!error ? error == null || (_response = error.response) == null ? void 0 : _response.requestId : undefined;
};
export const NonBlockerWrapper = _ref => {
  let {
    componentName,
    children
  } = _ref;
  const panorama = useEclipsePanorama();
  const {
    biLogger
  } = useBiLogger();
  const staticBiEventsFields = getStaticBiEventsFields();
  return /*#__PURE__*/React.createElement(QueriesErrorObserver, {
    onError: data => {
      if (!data.error) {
        return;
      }
      const originalMessage = data.error instanceof Error ? data.error.message : String(data.error);
      const errorMessage = `[${componentName}] ${originalMessage}`;
      const reportedError = data.error instanceof Error ? Object.assign(new Error(errorMessage), {
        stack: data.error.stack
      }) : new Error(errorMessage);
      const requestId = extractRequestId(data.error);
      panorama.reportError(reportedError, {
        tags: {
          componentName,
          errorType: 'NonBlocker',
          requestId
        }
      });
      biLogger == null || biLogger.report(packagePickerErrorSrc17Evid2236({
        ...staticBiEventsFields,
        errorType: 'NonBlocker',
        errorMessage,
        requestId
      }));
    },
    Error: () => null
  }, children);
};
//# sourceMappingURL=NonBlockerWrapper.js.map